import { render, staticRenderFns } from "./ProcessosJudiciais.vue?vue&type=template&id=361834cf&"
import script from "./ProcessosJudiciais.vue?vue&type=script&lang=js&"
export * from "./ProcessosJudiciais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports